export enum Opening {
  MIDDLE,
  BACK,
  FORWARD,
}